import React, { Component } from 'react';
import { BigNumber, ethers } from 'ethers';
import { getChainIdFromShortName, getProviderWithChainId, initProvider, MiningPoolAbi, tokenAbi, zeroAddress } from '../../utils/config';
import { Contract, Provider } from 'ethers-multicall';
import moment from 'moment-timezone';
import { eventBus } from '../../utils/tool';
import { getIpfsText } from '../../utils/ipfs';
import { connect } from "react-redux"
import store from '../../store';
import { withTranslation } from 'react-i18next';
import { getWalletSnapshot } from '../../utils/walletProviders';

import copy from 'copy-to-clipboard';


// import '@sweetalert2/theme-dark/dark.scss';

import StakeModal from './components/StakeModal/index'
import UnstakeModal from './components/UnstakeModal/index'
import IpfsPanel from './components/IpfsPanel/index'
import InviteConfirmModal from './components/InviteConfirmModal/index'
import WhitelistModal from './components/WhitelistModal/index'
import TokenStakingConsole from '../StakingConsole/TokenStakingConsole'
import ConsoleToast from '../StakingConsole/ConsoleToast'
import ConsoleDialog from '../StakingConsole/ConsoleDialog'
import TransactionSuccessDialog from '../StakingConsole/TransactionSuccess'
import { mapStakingError } from '../StakingConsole/errorMessages'
import { waitForTransaction } from '../StakingConsole/transactionFeedback'
import { buildEmergencyRewardWithdrawPlan, buildSetEmergencyWithdrawPlan, buildStopRewardPlan } from './transactionPlan'
import { calculateMaximumStakeAmount, getRewardClaimAudit, getRewardWithdrawalProtection, MAX_EARLY_WITHDRAWAL_AUDIT_USERS } from '../StakingConsole/stakingLimits'

moment.tz.setDefault('UTC') // global style

export class StakingOne extends Component {
    fetchRequestVersion = 0
    countdownTimerContext = null

    state = {
        data: {},
        tabData: [],
        tabContent: [],
        features: [],
        chain: '', // 公链
        contract: '', // 矿池地址
        account: '',
        ipfsInfo: {},
        stakeTokenInfo: {},
        rewardTokenInfo: {},
        poolInfo: {},
        showStakeModal: false,
        stakeAmountInput: 0, // 质押数量
        stakeMax: false, // 点了max按钮
        swalProps: {},
        reawardLoading: false,// 领取奖励的loading
        currentProvider: null,
        showUnstakeModal: false, // 展示解除质押按钮
        stopRewardLoading: false, // 停止质押的loading
        enableForceWithdrawLoading: false, // 强制解除质押的loading
        showTimeDetail: false, // 是否展示时间详情
        showIpfsPanel: false, // 展示ipfs信息
        countdown: {
            type: 0,
            ct: '00:00:00' // 时 分 秒
        },
        showInviteConfirmModal: false, // 展示确认邀请modal
        showWhitelistModal: false, // 设置白名单
        params: {},
        urlPath: '', // 当前的路径 主机+域名+#+hash
        invitorList: [], // 当前用户的邀请人列表信息
        invitorTotalCount: 0,
        perPage: 10,
        isAdmin: false, // 是否是管理员
        stakeUserList: [], // 质押用户列表
        adminInfo: {}, // 管理员信息,
        rewardClaimAudit: { status: 'idle', canWithdrawEarly: false },
        networkName: '',
        notShowList: [

        ], // 不显示交易对的列表
        customInfo: {},
        consoleToast: { show: false, message: '', tone: 'success' }
    }

    async initProvider(requireSelectedWallet = false) {
        let provider = null
        const chainId = this.state.chainId
        const wallet = getWalletSnapshot()
        if (wallet.account && wallet.provider) {
            try {
                const hexChainId = await wallet.provider.request({ method: 'eth_chainId' })
                const cid = parseInt(BigNumber.from(hexChainId).toString())
                if (chainId === cid) {
                    provider = new ethers.providers.Web3Provider(wallet.provider)
                }
            } catch (error) {
                if (requireSelectedWallet) throw error
            }
        }
        if (requireSelectedWallet && !provider) {
            throw new Error('Selected wallet is unavailable or connected to the wrong network')
        }
        if (!provider) {
            provider = getProviderWithChainId(chainId)
        }

        return provider
    }

    componentDidMount() {

        this.setState({
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        })
        this.walletConnectHandler = this.walletConnect.bind(this)
        this.forceWithdrawSuccessHandler = this.handleForceWithdrawSuccess.bind(this)
        this.withdrawSuccessHandler = this.handleWithDrawSuccess.bind(this)
        eventBus.addListener("walletConnect", this.walletConnectHandler)
        // 获取链和合约
        // 根据合约获取ipfs数据, 更新信息
        this.fetchData()

        // axios.get(`${BASE_URL}`)
        //     .then(res => {
        //         this.setState({
        //             data: res.data,
        //             tabData: res.data.tabData,
        //             tabContent: res.data.tabContent,
        //             features: res.data.features
        //         })
        //         // console.log(this.state.data)
        //     })
        //     .catch(err => console.log(err))

        eventBus.addListener('forceWithdrawSuccess', this.forceWithdrawSuccessHandler)
        eventBus.addListener('withdrawSuccess', this.withdrawSuccessHandler)

    }
    handleWithDrawSuccess() {
        this.fetchData()
    }

    handleForceWithdrawSuccess() {
        this.fetchData()
    }



    async getTokenInfo(tokenAddress, provider, chainId, currentWallet, miningContract) {
        let ethcallProvider = new Provider(provider)
        // await ethcallProvider.init()
        ethcallProvider = await initProvider(ethcallProvider, chainId)

        const token = new Contract(tokenAddress, tokenAbi)

        const call = [token.name(), token.symbol(), token.decimals(), token.totalSupply()]
        if (currentWallet) {
            call.push(token.allowance(currentWallet, miningContract))
            call.push(token.balanceOf(currentWallet))
        }
        const res = await ethcallProvider.all(call)
        const decimals = parseInt(res[2].toString())
        const d = Math.pow(10, decimals)

        let allowance = 0
        let balance = 0
        let balanceBigNumber = null
        if (currentWallet) {
            allowance = res[4].toString()
            balance = res[5].toString()
            balanceBigNumber = res[5] // 是一个bigNumber
        }

        const fatTokenAbi = [
            'function token0() external view returns(address)',
            'function token1() external view returns(address)',
        ]
        let isPairToken = false
        let token0Info = {}
        let token1Info = {}
        try {
            const pairToken = new Contract(tokenAddress, fatTokenAbi)
            const call = [pairToken.token0(), pairToken.token1()]
            const res2 = await ethcallProvider.all(call)
            isPairToken = true
            token0Info = await this.getTokenInfo(res2[0], provider, chainId, currentWallet, miningContract)
            token1Info = await this.getTokenInfo(res2[1], provider, chainId, currentWallet, miningContract)



        } catch (e) {

        }

        return {
            name: res[0],
            symbol: res[1],
            decimals,
            totalSupply: res[3].toString() / d,
            address: tokenAddress,
            allowance,
            balance,
            balanceBigNumber,
            isPairToken,
            token0Info,
            token1Info
        }
    }
    componentWillUnmount() {
        this.invalidateFetchData()
        this.stopCountdown()
        eventBus.removeListener("walletConnect", this.walletConnectHandler)
        eventBus.removeListener('forceWithdrawSuccess', this.forceWithdrawSuccessHandler)
        eventBus.removeListener('withdrawSuccess', this.withdrawSuccessHandler)
        this.countdownTimer && clearInterval(this.countdownTimer)
    }



    walletConnect(v) {
        this.invalidateFetchData()
        const account = v?.account || ''
        const accountState = {
            stakeTokenInfo: {},
            rewardTokenInfo: {},
            poolInfo: this.getPublicPoolInfo(),
            invitorList: [],
            invitorTotalCount: 0,
            stakeUserList: [],
            adminInfo: {},
            isAdmin: false,
            showStakeModal: false,
            showUnstakeModal: false,
        }
        if (!account) {
            this.setState({
                account: '',
                currentProvider: null,
                ...accountState,
            }, () => this.fetchData())
            return
        }
        this.setState({
            account,
            currentProvider: v.provider || getWalletSnapshot().provider || null,
            ...accountState,
        }, () => this.fetchData())
    }
    getPublicPoolInfo() {
        return {
            ...this.state.poolInfo,
            pendingReward: '0',
            userStakedAmount: 0,
            userStakeAmountBigNumber: null,
            userExtendPownerAmount: 0,
            userCanWithdraw: false,
            unlockTime: 0,
            myInvitor: '',
        }
    }
    invalidateFetchData() {
        this.fetchRequestVersion += 1
    }
    getFetchContext({ account = this.state.account, chainId = this.state.chainId, contract = this.state.contract } = {}) {
        return {
            account: account || '',
            chainId,
            contract: (contract || '').toLowerCase(),
            requestVersion: this.fetchRequestVersion,
        }
    }
    isFetchContextCurrent(context) {
        return Boolean(context)
            && context.requestVersion === this.fetchRequestVersion
            && context.account === (this.state.account || '')
            && context.chainId === this.state.chainId
            && context.contract === (this.state.contract || '').toLowerCase()
    }
    setStateForFetch(context, patch, callback) {
        if (!this.isFetchContextCurrent(context)) return
        this.setState(() => this.isFetchContextCurrent(context) ? patch : null, () => {
            if (this.isFetchContextCurrent(context)) callback?.()
        })
    }
    stopCountdown(timerContext) {
        if (timerContext && timerContext !== this.countdownTimerContext) return
        if (this.countdownTimer) clearInterval(this.countdownTimer)
        this.countdownTimer = null
        this.countdownTimerContext = null
    }
    stopCountdownForDifferentPool(context) {
        const timerContext = this.countdownTimerContext
        if (!timerContext) return
        if (timerContext.chainId !== context.chainId || timerContext.contract !== context.contract) {
            this.stopCountdown(timerContext)
        }
    }
    startCountdown(context) {
        if (!this.isFetchContextCurrent(context)) return
        this.stopCountdown()
        const timerContext = {
            chainId: context.chainId,
            contract: context.contract,
            requestVersion: context.requestVersion,
        }
        this.countdownTimerContext = timerContext
        this.countdownTimer = setInterval(() => this.calcCountdownInfo(timerContext), 1000)
    }
    async fetchData() {
        const requestVersion = ++this.fetchRequestVersion
        // 获取url参数
        const query = new URL(window.location.href)
        console.log(query, 'aaa')
        const r = query.hash.replace('#/', '').split('/')
        const ps = r[1].split('?')
        let contract = ps[0]
        const hrefArr = (query.origin + '/' + query.hash).split('?')

        let params = {}
        if (ps.length > 0) {
            const queryParams = new URLSearchParams(ps[1])
            // 获取inviter
            const m = {}
            for (const [key, value] of queryParams.entries()) {
                m[key] = value || ''
            }
            params = m
        }
        // 获取代币信息
        // 如果当前钱包和选择的公链一致, 则使用当前的provider
        // 如果不一致, 则自动选择provider
        const chainId = getChainIdFromShortName(r[0])
        const context = {
            account: this.state.account || '',
            chainId,
            contract: contract.toLowerCase(),
            requestVersion,
        }
        const poolChanged = Number(this.state.chainId) !== Number(chainId)
            || (this.state.contract || '').toLowerCase() !== context.contract
        this.stopCountdownForDifferentPool(context)


        this.setState({
            params,
            chain: r[0],
            contract,
            urlPath: hrefArr[0],
            ...(poolChanged ? {
                showStakeModal: false,
                showUnstakeModal: false,
            } : {}),
            chainId
        }, async () => {
            if (!this.isFetchContextCurrent(context)) return

            const provider = await this.initProvider()
            if (!this.isFetchContextCurrent(context)) return

            // 获取矿池信息
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, chainId)
            if (!this.isFetchContextCurrent(context)) return

            const pool = new Contract(contract, MiningPoolAbi)

            // 开始时间 结束时间 最大质押量 锁仓时间 apr 我的质押量 我的收益
            const calls1 = [
                pool.stakedToken(),
                pool.rewardToken(),
                pool.startBlock(),
                pool.bonusEndBlock(),
                pool.poolLimitPerUser(),
                pool.numberBlocksForUserLimit(),
                pool.lengthOflockTime(),
                pool.owner(),
                pool.enableInviter(),
                pool._baseURI(),
                pool.usercanemergencyWithdraw(), // 是否允许紧急提现
                pool.lenOfInvitorRewardPercentList(), // 邀请人奖励比例列表长度
                pool.feeOfOpenInviter(), // 开启邀请人功能的费用
            ]


            if (context.account) {
                //  我的收益 我的质押量 当前能否提现 我的解锁时间
                calls1.push(pool.pendingReward(context.account))
                calls1.push(pool.userInfo(context.account))
                calls1.push(pool.getUserCanWithdraw(context.account))
                calls1.push(pool.getUnlockTime(context.account))
                calls1.push(pool._invitor(context.account))
            }

            const res1 = await ethcallProvider.all(calls1)
            if (!this.isFetchContextCurrent(context)) return

            const miningInfo = {
                stakeToken: res1[0],
                rewardToken: res1[1],
                startTime: moment(parseInt(res1[2].toString()) * 1000),
                endTime: moment(res1[3].toString() * 1000),
                poolLimitPerUser: parseInt(res1[4].toString()),
                poolLimitPerUserBigNumber: res1[4],
                numberBlocksForUserLimit: parseInt(res1[5].toString()),
                deadline: moment((parseInt(res1[2].toString()) + parseInt(res1[5].toString())) * 1000),
                lockTime: parseInt(res1[6].toString()),
                owner: res1[7],
                enableInvitor: res1[8], // 是否有邀请人
                ipfsKey: res1[9],
                allowMergencyWithdraw: res1[10],
                invitorRewardPercentListLength: parseInt(res1[11].toString()),
                feeOfOpenInviter: parseInt(res1[12].toString()) / 1e18,
                pendingReward: res1[13] ? res1[13].toString() : '0',
                userStakedAmount: res1[14] ? parseInt(res1[14].amount.toString()) : 0,
                userStakeAmountBigNumber: res1[14] ? res1[14].amount : null, // 质押量的bigNumber
                userExtendPownerAmount: res1[14] ? parseInt(res1[14].extendPower.toString()) : 0,
                userCanWithdraw: res1[15] || false,
                unlockTime: res1[16] ? parseInt(res1[16].toString()) : 0,
                myInvitor: (res1[17] && res1[17] !== zeroAddress) ? res1[17] : ''
            }

            //  获取邀请比例列表
            if (miningInfo.invitorRewardPercentListLength > 0) {
                const calls2 = []
                for (let i = 0; i < miningInfo.invitorRewardPercentListLength; i++) {
                    calls2.push(pool.invitorRewardPercentList(i))
                }
                const res2 = await ethcallProvider.all(calls2)
                if (!this.isFetchContextCurrent(context)) return
                const iList = []
                res2.forEach((item, index) => {
                    iList.push(item.toString() / 100)
                })
                miningInfo.invitorRewardPercentList = iList
            } else {
                miningInfo.invitorRewardPercentList = []
            }


            // 如果开启了邀请功能, 则获取下级列表
            if (miningInfo.enableInvitor) {
                this.getInvitorList(1, context)
            }

            // this.state.poolInfo.owner.toLowerCase() === this.state.account.toLowerCase()
            const isAdmin = miningInfo.owner?.toLowerCase() === context.account.toLowerCase()

            if (isAdmin) {
                // 获取管理员相关信息
                this.getStakeListForAdmin(1, context)
            }

            this.setStateForFetch(context, {
                poolInfo: miningInfo,
                isAdmin,
                rewardClaimAudit: { status: isAdmin ? 'idle' : 'not-owner', canWithdrawEarly: false },
                chainId,
                networkName: r[0]
            }, () => {
                this.startCountdown(context)
            })

            // 获取ipfs信息
            if (miningInfo.ipfsKey) {
                getIpfsText(miningInfo.ipfsKey)
                    .then(res => {
                        if (!this.isFetchContextCurrent(context)) return
                        console.log('ipfs信息', JSON.parse(res))
                        this.setStateForFetch(context, {
                            ipfsInfo: JSON.parse(res)
                        })
                        store.dispatch({
                            type: 'setMiningInfo',
                            value: JSON.parse(res)
                        })
                    })
            }

            // 获取质押代币信息
            const stakeTokenInfo = await this.getTokenInfo(miningInfo.stakeToken, provider, chainId, context.account, contract)
            if (!this.isFetchContextCurrent(context)) return
            // 获取奖励代币信息
            const rewardTokenInfo = await this.getTokenInfo(miningInfo.rewardToken, provider, chainId, context.account, contract)
            if (!this.isFetchContextCurrent(context)) return

            console.log('质押代币信息', stakeTokenInfo)
            // 如果是定制的合约, 则获取定制信息
            if (contract.toLowerCase() === '0x2f0756315202126bE6CE7C0ffD0c4D460c9B8b5e'.toLowerCase()) {
                // 获取池子内的两个代币的数量
                // 获取我的LP的余额
                // 获取池子内core的数量, 获取core的价格, 然后乘以2
                const token0T = new Contract(stakeTokenInfo.token0Info.address, tokenAbi, provider)
                const token1T = new Contract(stakeTokenInfo.token1Info.address, tokenAbi, provider)
                const shadow0T = new Contract('0x191e94fa59739e188dce837f7f6978d84727ad01', tokenAbi, provider) // core
                const shadow1T = new Contract('0x81bcea03678d1cef4830942227720d542aa15817', tokenAbi, provider) // usdt
                const lpCalls = [
                    token0T.balanceOf(miningInfo.stakeToken),
                    token1T.balanceOf(miningInfo.stakeToken),
                    shadow0T.balanceOf('0x7cc4140561792eb8f7c5cea7a2d7b535eb970f29'),
                    shadow1T.balanceOf('0x7cc4140561792eb8f7c5cea7a2d7b535eb970f29'),
                ]

                const lpResInfo = await ethcallProvider.all(lpCalls)
                if (!this.isFetchContextCurrent(context)) return
                console.log(lpResInfo, 'aaaaaaa')
                const corePrice = (lpResInfo[3].toString() / 1e18) / (lpResInfo[2].toString() / 1e18)
                console.log('corePrice', corePrice)

                // const myStaked = stakeTokenInfo.balanceBigNumber.toString() / Math.pow(10, stakeTokenInfo.decimals)
                const myStaked = miningInfo.userStakedAmount / Math.pow(10, stakeTokenInfo.decimals)
                const rate = myStaked / stakeTokenInfo.totalSupply
                console.log('corePrice', '所占比例', rate)
                // 当前市值
                const cap = lpResInfo[0].toString() / 1e18 * corePrice * 2
                console.log('corePrice', '当前市值', cap)
                // 能兑换出的数量
                const coreAmount = lpResInfo[0].toString() / 1e18 * rate
                const ctAmount = lpResInfo[1].toString() / Math.pow(10, stakeTokenInfo.token1Info.decimals) * rate


                const customInfo = {
                    cap: cap * rate, // 当前的流动价值
                    swapString: `${coreAmount.toFixed(2)}CORE/${ctAmount.toFixed(2)}CT`, // xxx core /xxx CT
                    showCustom: true
                }
                console.log('corePrice', '当前市值', customInfo)
                this.setStateForFetch(context, {
                    customInfo
                })
            }

            console.log('质押代币信息', stakeTokenInfo)
            // 设置到state中
            this.setStateForFetch(context, {
                stakeTokenInfo,
                rewardTokenInfo
            })

        })



    }


    checkNetwork() {
        if (this.state.chainId !== this.props.chainId) {
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: this.props.t('当前网络不匹配, 请连接CORE钱包').replace('{net}', this.state.networkName.toUpperCase()),
            })
            return false
        }
        return true
    }

    handleErr(e) {
        this.showMessageModal({
            show: true,
            title: this.props.t('错误'),
            text: mapStakingError(e, this.props.t),
        })
    }

    async calcCountdownInfo(timerContext = this.countdownTimerContext) {
        if (timerContext && timerContext !== this.countdownTimerContext) return
        if (timerContext && (timerContext.chainId !== this.state.chainId || timerContext.contract !== (this.state.contract || '').toLowerCase())) {
            this.stopCountdown(timerContext)
            return
        }
        const now = moment()
        const { startTime, endTime, unlockTime } = this.state.poolInfo
        if (!startTime || !endTime) return

        this.setState({
            poolInfo: {
                ...this.state.poolInfo,
                unlockTime: (unlockTime - 1 > 0) ? unlockTime - 1 : 0
            }
        })
        let type = 1 // 1:开始倒计时 2:结束倒计时 3: 已结束
        // 倒计时
        let countdown = 0


        if (startTime.isAfter(endTime)) {
            type = 3
        } else if (now.isBefore(startTime)) {
            countdown = startTime.diff(now, 'seconds')
        } else if (now.isBefore(endTime) && now.isAfter(startTime)) {
            type = 2
            countdown = endTime.diff(now, 'seconds')
        } else if (now.isAfter(endTime)) {
            type = 3
        }

        // 倒计时文案
        let days = Math.floor(countdown / 86400)
        let hours = Math.floor((countdown - days * 86400) / 3600)
        let minutes = Math.floor((countdown - days * 86400 - hours * 3600) / 60)
        let seconds = Math.floor(countdown - days * 86400 - hours * 3600 - minutes * 60)
        days = days < 10 ? '0' + days : days
        hours = hours < 10 ? '0' + hours : hours
        minutes = minutes < 10 ? '0' + minutes : minutes
        seconds = seconds < 10 ? '0' + seconds : seconds
        const countdownText = `${days}:${hours}:${minutes}:${seconds}`

        this.setState({
            countdown: {
                type,
                ct: countdownText,
            }
        })

    }

    async getStakeListForAdmin(page, fetchContext = this.getFetchContext()) {
        // 获取质押总量 当前质押总人数 当前质押总算力
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return
        }
        // 获取下级列表
        const p = await this.initProvider()
        if (!this.isFetchContextCurrent(fetchContext)) return
        let ethcallProvider = new Provider(p)
        ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
        if (!this.isFetchContextCurrent(fetchContext)) return
        const pool = new Contract(fetchContext.contract, MiningPoolAbi)

        const calls1 = [pool.getUsersCount(), pool.getTotalPower(), pool.getTotalStakeAmount()]
        const res1 = await ethcallProvider.all(calls1)
        if (!this.isFetchContextCurrent(fetchContext)) return
        console.log('admin111', res1)
        const adminInfo = {
            userCount: parseInt(res1[0].toString()), // 质押总人数
            totalPower: res1[1].toString(), // 质押总算力
            totalStakeAmount: res1[2].toString(), // 质押总量
        }

        // 获取质押列表
        const perPage = this.state.perPage

        const calls2 = []
        for (let i = adminInfo.userCount - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls2.push(pool.getUserById(ethers.utils.parseUnits(i + '', 0)))
            if (calls2.length >= perPage) break
        }
        const list = await ethcallProvider.all(calls2)
        if (!this.isFetchContextCurrent(fetchContext)) return

        const arr = list.map(item => {
            // 已提升算力 已领取 质押数 奖励数 用户地址 邀请人
            return {
                invitor: item.invitor,
                userAddr: item.userAddr,
                stakedTokenAmount: item.stakeAmount.toString(),
                rewardTokenAmount: item.rewardAmount.toString(),
                claimedTokenAmount: item.hasBeenClaimdReward.toString(),
                extendPower: item.extendPower.toString(),
            }
        })
        console.log('第', page, '页信息', list, arr)

        this.setStateForFetch(fetchContext, {
            adminInfo,
            stakeUserList: arr,
        })

    }

    async getInvitorList(page, fetchContext = this.getFetchContext()) {
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return
        }
        // 获取下级列表
        const p = await this.initProvider()
        if (!this.isFetchContextCurrent(fetchContext)) return
        let ethcallProvider = new Provider(p)
        ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
        if (!this.isFetchContextCurrent(fetchContext)) return

        // 获取下级总数, 用来分页
        // 按照倒序, 获取下级地址
        // 根据下级地址, 获取信息
        const pool = new Contract(fetchContext.contract, MiningPoolAbi)

        // 获取总数
        // 切片 获取信息
        const calls1 = [pool.inviterListsForUserTotal(fetchContext.account)]
        const res1 = await ethcallProvider.all(calls1)
        if (!this.isFetchContextCurrent(fetchContext)) return
        console.log('总数为', res1[0].toString())
        const total = res1[0].toString()
        // 分页
        const perPage = this.state.perPage

        const calls2 = []
        for (let i = total - ((page - 1) * perPage) - 1; i >= 0; i--) {
            calls2.push(pool.inviterListsForUserPage(fetchContext.account, ethers.utils.parseUnits(i + '', 0)))
            if (calls2.length >= perPage) break
        }
        const list = await ethcallProvider.all(calls2)
        if (!this.isFetchContextCurrent(fetchContext)) return

        const arr = list.map(item => {
            // 已提升算力 已领取 质押数 奖励数 用户地址 邀请人
            return {
                invitor: item.invitor,
                userAddr: item.userAddr,
                stakedTokenAmount: item.stakeAmount.toString(),
                rewardTokenAmount: item.rewardAmount.toString(),
                claimedTokenAmount: item.hasBeenClaimdReward.toString(),
                extendPower: item.extendPower.toString(),
            }
        })
        console.log('第', page, '页信息', list, arr)

        this.setState({
            invitorList: arr,
            invitorTotalCount: parseInt(total),
            perPage
        })




    }

    async enableForceWithdraw() {
        if (this.checkNetwork() === false) return false
        // 允许紧急撤离矿池
        const r = this.state.poolInfo.allowMergencyWithdraw ? false : true
        this.setState({
            enableForceWithdrawLoading: true
        })
        try {
            const p = await this.initProvider(true)
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildSetEmergencyWithdrawPlan(r)
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            this.showTransactionSuccess({
                title: this.props.t('紧急撤离设置成功'),
                description: r ? this.props.t('用户现在可以使用紧急撤离。') : this.props.t('用户紧急撤离权限已关闭。'),
                ...result,
            })
            this.fetchData()
            return true
        } catch (e) {
            this.handleErr(e)
            throw e
        } finally {
            this.setState({
                enableForceWithdrawLoading: false
            })
        }
    }

    async checkRewardClaimAudit(fetchContext = this.getFetchContext()) {
        if (!fetchContext.account || !this.isFetchContextCurrent(fetchContext)) {
            return { status: 'not-owner', canWithdrawEarly: false }
        }
        this.setStateForFetch(fetchContext, {
            rewardClaimAudit: { status: 'checking', canWithdrawEarly: false },
        })
        try {
            const provider = await this.initProvider()
            if (!this.isFetchContextCurrent(fetchContext)) return { status: 'stale', canWithdrawEarly: false }
            let ethcallProvider = new Provider(provider)
            ethcallProvider = await initProvider(ethcallProvider, fetchContext.chainId)
            const pool = new Contract(fetchContext.contract, MiningPoolAbi)
            const [countValue] = await ethcallProvider.all([pool.getUsersCount()])
            const userCount = Number(countValue.toString())
            let users = []
            if (userCount <= MAX_EARLY_WITHDRAWAL_AUDIT_USERS) {
                const calls = Array.from({ length: userCount }, (_item, index) => (
                    pool.getUserById(ethers.utils.parseUnits(String(index), 0))
                ))
                users = calls.length > 0 ? await ethcallProvider.all(calls) : []
            }
            const audit = getRewardClaimAudit({ userCount, users })
            this.setStateForFetch(fetchContext, { rewardClaimAudit: audit })
            return audit
        } catch (error) {
            const audit = { status: 'failed', canWithdrawEarly: false, error: mapStakingError(error, this.props.t) }
            this.setStateForFetch(fetchContext, { rewardClaimAudit: audit })
            return audit
        }
    }

    async withdrawRemindRewardTokens() {
        // 提取剩余奖励代币
        if (this.checkNetwork() === false) return false

        // 当前时间-结束时间不超过24小时
        const protection = getRewardWithdrawalProtection({
            endTimeUnix: this.state.poolInfo.endTime.unix(),
            nowUnix: moment().unix(),
        })
        let canWithdraw = protection.isAvailable
        if (!canWithdraw) {
            const audit = await this.checkRewardClaimAudit()
            canWithdraw = audit.canWithdrawEarly
        }
        if (!canWithdraw) {
            // 弹出提示
            const countdown = protection.remainingSeconds
            const hours = Math.floor(countdown / 3600)
            const minutes = Math.floor((countdown - hours * 3600) / 60)
            const countdownText = `${hours} ${this.props.t('小时')} ${minutes} ${this.props.t('分钟')}`
            this.showMessageModal({
                show: true,
                title: this.props.t('错误'),
                text: this.props.t('距离矿池结束时间不足24小时, 剩余时间为 ') + countdownText
            })
            return false
        }

        this.setState({
            stopRewardLoading: true
        })
        try {
            // 获取奖励代币余额, 然后提取代币
            const p = await this.initProvider(true)
            const token = new ethers.Contract(this.state.rewardTokenInfo.address, tokenAbi, p.getSigner())
            const balance = await token.balanceOf(this.state.contract)
            console.log('余额为', balance.toString() / Math.pow(10, this.state.rewardTokenInfo.decimals))
            const balanceString = balance.toString() / Math.pow(10, this.state.rewardTokenInfo.decimals)
            if (parseFloat(balanceString) === 0) {
                throw new Error(this.props.t('矿池内奖励代币余额为0'))
            }
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildEmergencyRewardWithdrawPlan(balance)
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            this.showTransactionSuccess({
                title: this.props.t('剩余奖励提取成功'),
                description: this.props.t('矿池中的剩余奖励代币已返回管理员钱包。'),
                amount: balanceString,
                symbol: this.state.rewardTokenInfo.symbol,
                amountLabel: this.props.t('提取数量'),
                ...result,
            })
            return true
        } catch (e) {
            this.handleErr(e)
            throw e
        } finally {
            this.setState({
                stopRewardLoading: false
            })
        }
    }

    async stopRewardLogic() {
        console.log('结束矿池')
        if (this.checkNetwork() === false) return false
        this.setState({
            stopRewardLoading: true
        })

        try {
            const p = await this.initProvider(true)
            const a = new ethers.Contract(this.state.contract, MiningPoolAbi, p.getSigner())
            const plan = buildStopRewardPlan()
            const tx = await a[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            this.showTransactionSuccess({
                title: this.props.t('矿池停止成功'),
                description: this.props.t('当前矿池已停止继续发放奖励。'),
                ...result,
            })
            return true
        } catch (e) {
            this.handleErr(e)
            throw e
        } finally {
            this.setState({
                stopRewardLoading: false
            })
        }
    }

    showMessageModal(info) {
        this.setState({
            swalProps: {
                show: false,
                title: '',
                text: '',
            }
        }, () => {
            this.setState({
                swalProps: {
                    ...info
                }
            })
        })

    }



    getLockTimeString(time) {
        const t = parseInt(time)
        const day = Math.floor(t / 86400)
        const hour = Math.floor((t - day * 86400) / 3600)
        const minute = Math.floor((t - day * 86400 - hour * 3600) / 60)
        const second = t - day * 86400 - hour * 3600 - minute * 60
        return `${day > 0 ? (day + this.props.t('天')) : ''} ${hour > 0 ? (hour + this.props.t('小时')) : ''} ${minute > 0 ? (minute + this.props.t('分钟')) : ''} ${second > 0 ? (second + this.props.t('秒')) : ''}`
    }

    generateShareLink() {
        // http://localhost:3000/#/core/0x928D87B7c6Ea72a44E86d72990d199C9905202f9?invitor=0x928D87B7c6Ea72a44E86d72990d199C9905202f9
        return `${this.state.urlPath}?invitor=${this.props.account}`
    }

    showTransactionSuccess(info) {
        this.showMessageModal({
            show: true,
            variant: 'transaction-success',
            wallet: this.state.account,
            chainId: this.state.chainId,
            ...info,
        })
    }

    openProjectInfo() {
        if (this.checkNetwork() === false) return
        this.ipfsPanelRef.setIpfsInfo({ ...this.state.ipfsInfo }).then(() => this.setState({ showIpfsPanel: true }))
    }

    openInviteSettings() {
        if (this.checkNetwork() === false) return
        this.setState({ showInviteConfirmModal: true })
    }

    openWhitelistSettings() {
        if (this.checkNetwork() === false) return
        this.setState({ showWhitelistModal: true })
    }

    copyPoolAddress() {
        if (this.checkNetwork() === false) return
        copy(window.location.href)
        this.showMessageModal({
            show: true,
            title: this.props.t('复制成功'),
            html: `<p>${window.location.href} </p>`,
            icon: 'success'
        })
    }

    canBindDomain() {
        const href = typeof window === 'undefined' ? '' : window.location.href
        return href.indexOf('fatsale') > -1 || href.indexOf('localhost') > -1
    }

    showDomainBindingInfo() {
        if (this.checkNetwork() === false) return
        copy(window.location.href)
        this.showMessageModal({
            show: true,
            title: this.props.t('绑定独立域名'),
            html: `<div><p>${this.props.t('平台支持绑定独立域名并部署在单独的服务器中')}</p><p>${this.props.t('此功能需要自行购买域名, 并额外支付部署费用以及后续维护费用')}</p><p>${this.props.t('具体请咨询')} <a target="_blank" href="https://t.me/safu_contract">${this.props.t('客服')}</a></p></div>`,
        })
    }

    copyValue(value, message = this.props.t('复制成功')) {
        if (!value) return
        copy(value)
        this.setState({ consoleToast: { show: true, message, tone: 'success' } })
    }

    setStakeAmount(value) {
        this.setState({ stakeAmountInput: value, stakeMax: false })
    }

    setStakeMax() {
        const decimals = parseInt(this.state.stakeTokenInfo.decimals)
        const balance = this.state.stakeTokenInfo.balanceBigNumber || this.state.stakeTokenInfo.balance || 0
        const maximum = calculateMaximumStakeAmount({
            balance,
            poolLimitPerUser: this.state.poolInfo.poolLimitPerUserBigNumber || this.state.poolInfo.poolLimitPerUser || 0,
            userStakedAmount: this.state.poolInfo.userStakeAmountBigNumber || this.state.poolInfo.userStakedAmount || 0,
        })
        const balanceBigNumber = BigNumber.from(balance)
        this.setState({
            stakeAmountInput: ethers.utils.formatUnits(maximum, decimals),
            stakeMax: maximum.eq(balanceBigNumber),
        })
    }

    handleStake() {
        if (this.checkNetwork() === false) return
        if (!parseFloat(this.state.stakeAmountInput)) {
            this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('请输入正确的质押数量') })
            return
        }
        const decimals = parseInt(this.state.stakeTokenInfo.decimals)
        const balance = this.state.stakeTokenInfo.balance / Math.pow(10, decimals)
        if (parseFloat(this.state.stakeAmountInput) > parseFloat(balance)) {
            this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('余额不足') })
            return
        }
        if (parseFloat(this.state.poolInfo.poolLimitPerUser) > 0 && this.state.poolInfo.poolLimitPerUser / Math.pow(10, decimals) < this.state.poolInfo.userStakedAmount / Math.pow(10, decimals) + parseFloat(this.state.stakeAmountInput)) {
            this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('质押数量已经达到最大') })
            return
        }
        this.setState({ showStakeModal: true })
        this.stakeModalRef.setApproveInfo({
            amount: this.state.stakeAmountInput,
            tokenDecimals: decimals,
            stakeContract: this.state.contract,
            tokenAddress: this.state.stakeTokenInfo.address,
            tokenSymbol: this.state.stakeTokenInfo.symbol,
            currentWallet: this.state.account,
            chainId: this.state.chainId,
            stakeMax: this.state.stakeMax,
            amountBigNumber: this.state.stakeMax ? this.state.stakeTokenInfo.balanceBigNumber : ethers.utils.parseUnits(this.state.stakeAmountInput + '', decimals),
            stakeTokenBalanceBigNumber: this.state.stakeTokenInfo.balanceBigNumber,
        }).then(() => this.stakeModalRef.handleLogic())
    }

    async claimReward() {
        if (this.checkNetwork() === false) return
        const pendingReward = BigNumber.from(this.state.poolInfo.pendingReward || 0)
        if (pendingReward.lte(0)) {
            this.showMessageModal({ show: true, title: this.props.t('错误'), text: this.props.t('暂无可领取奖励') })
            return
        }
        this.setState({ reawardLoading: true })
        try {
            const provider = await this.initProvider(true)
            const contract = new ethers.Contract(this.state.contract, MiningPoolAbi, provider.getSigner())
            const tx = await contract.withdraw(ethers.utils.parseUnits('0', 0))
            const result = await waitForTransaction(tx)
            this.showTransactionSuccess({
                title: this.props.t('奖励领取成功'),
                description: this.props.t('奖励已发送至当前钱包。'),
                amount: ethers.utils.formatUnits(pendingReward, this.state.rewardTokenInfo.decimals),
                symbol: this.state.rewardTokenInfo.symbol,
                amountLabel: this.props.t('领取奖励'),
                ...result,
            })
            this.fetchData()
        } catch (error) {
            this.handleErr(error)
        }
        this.setState({ reawardLoading: false })
    }

    openUnstake() {
        if (this.checkNetwork() === false) return
        this.unStakeModalRef.setStakeInfo({
            stakedAmount: this.state.poolInfo.userStakedAmount,
            userCanWithdraw: this.state.poolInfo.allowMergencyWithdraw,
            stakeTokenInfo: this.state.stakeTokenInfo,
            stakeContract: this.state.contract,
            stakedAmountBigNumber: this.state.poolInfo.userStakeAmountBigNumber,
            currentWallet: this.state.account,
            chainId: this.state.chainId,
        }).then(() => this.setState({ showUnstakeModal: true }))
    }

    render() {
        document.title = this.props.t('质押挖矿') + ' | Fatsale'
        const message = this.state.swalProps || {}
        return <section className="staking-console-app">
            {message.variant === 'transaction-success'
                ? <TransactionSuccessDialog {...message} t={this.props.t} onClose={() => this.setState({ swalProps: { ...message, show: false } })} />
                : <ConsoleDialog show={Boolean(message.show)} onClose={() => this.setState({ swalProps: { ...message, show: false } })} closeLabel={this.props.t('关闭')} title={message.title || this.props.t('提示')} icon={message.icon === 'success' ? 'fa-check' : 'fa-exclamation-triangle'} tone={message.icon === 'success' ? 'default' : 'danger'} footer={<button type="button" className={`console-button ${message.icon === 'success' ? 'console-button--primary' : 'console-button--danger'}`} onClick={() => this.setState({ swalProps: { ...message, show: false } })}>{this.props.t('我知道了')}</button>}>
                    {message.html ? <div className="console-message-html" dangerouslySetInnerHTML={{ __html: message.html }} /> : <p className="console-message-text">{message.text}</p>}
                </ConsoleDialog>}
            <ConsoleToast {...this.state.consoleToast} closeLabel={this.props.t('关闭')} onClose={() => this.setState({ consoleToast: { ...this.state.consoleToast, show: false } })} />
            <WhitelistModal poolAddress={this.state.contract} show={this.state.showWhitelistModal} handleClose={() => this.setState({ showWhitelistModal: false })} ok={(result) => { this.fetchData(); this.setState({ showWhitelistModal: false }); this.showTransactionSuccess(result) }} />
            <InviteConfirmModal invitorRewardPercentList={this.state.poolInfo?.invitorRewardPercentList} fee={this.state.poolInfo.feeOfOpenInviter} poolAddress={this.state.contract} show={this.state.showInviteConfirmModal} open={this.state.poolInfo.enableInvitor} handleClose={() => this.setState({ showInviteConfirmModal: false })} ok={(result) => { this.fetchData(); this.setState({ showInviteConfirmModal: false }); this.showTransactionSuccess(result) }} />
            <IpfsPanel onRef={node => this.ipfsPanelRef = node} handleClose={() => this.setState({ showIpfsPanel: false })} info={this.state.ipfsInfo} contract={this.state.contract} show={this.state.showIpfsPanel} ok={(result) => { this.fetchData(); this.setState({ showIpfsPanel: false }); this.showTransactionSuccess(result) }} />
            <UnstakeModal onRef={node => this.unStakeModalRef = node} handleClose={() => this.setState({ showUnstakeModal: false })} show={this.state.showUnstakeModal} />
            <StakeModal invitor={this.state.params['invitor'] || ''} onRef={node => this.stakeModalRef = node} handleClose={() => this.setState({ showStakeModal: false })} ok={() => { this.setState({ stakeAmountInput: '' }); this.fetchData() }} show={this.state.showStakeModal} />
            <TokenStakingConsole controller={this} />
        </section>
    }
}

// export default StakingOne;

function mapStateToProps(state) {
    const { account, chainId } = state;
    return {
        account,
        chainId
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(withTranslation()(StakingOne))
